// extracted by mini-css-extract-plugin
export var banner = "_22-0";
export var icon = "_22-1";
export var message = "_22-2";